module.exports = __webpack_public_path__ + "img/icon_pdf.ea02ae53.png";